import { withWorkSummaryDetailView } from '../../components/WorkSummaryDetailView'

const AssignmentStaffWorkSummaryDetailView = withWorkSummaryDetailView(
  'Incoming Assignments',
  (workSummary) => workSummary.incomingJobAssignments,
)

export default AssignmentStaffWorkSummaryDetailView
